import { useRoutePermission } from 'hooks/useRoutePermission';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

function DashboardRoute({ ...props }) {
  // MARK: --- PROPERTIES ---
  const { user, agencyRoleList, permissionList } = useSelector((state) => state.auth);
  const { firstAllowedPath, isPermissionReady } = useRoutePermission(user, agencyRoleList, permissionList);

  if (_.isEmpty(user) || !isPermissionReady) return <div>Loading...</div>;
  return firstAllowedPath
    ? <Navigate to={firstAllowedPath} replace />
    : <div>Không có quyền truy cập màn hình nào.</div>;
}

export default DashboardRoute;
